// PERF: Fix jQuery non-passive event listener violations
// This patch makes jQuery touch events passive by default for better scroll performance
(function () {
  if (window.jQuery) {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (type, listener, options) {
      // Make touch events passive by default for better scroll performance
      if (['touchstart', 'touchmove', 'wheel', 'mousewheel'].includes(type)) {
        if (typeof options === 'boolean') {
          options = { passive: true, capture: options };
        } else if (typeof options === 'object' && options !== null) {
          // Respect explicit passive: false (needed for carousel trackpad scrolling)
          if (options.passive === false) {
            // Don't override - keep passive: false
          } else {
            options = { ...options, passive: true };
          }
        } else {
          options = { passive: true };
        }
      }
      return originalAddEventListener.call(this, type, listener, options);
    };
  }
})();

// PERF: Defer collection-tabs initialization until visible to reduce main-thread blocking
function initCollectionTabs() {
  // The collection-tabs will be initialized by carousel-manager.js
  // This just ensures it happens when visible
  if (window.HomepageCarousels && window.HomepageCarousels.HomepageCarouselManager) {
    // Trigger any pending initialization
    window.HomepageCarousels.HomepageCarouselManager.triggerResize();
  }
}

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      observer.disconnect();
      initCollectionTabs();
    }
  }, { rootMargin: '100px' });

  const targetElement = document.querySelector('.collection-tabs-carousel');
  if (targetElement) {
    observer.observe(targetElement);
  } else {
    initCollectionTabs(); // Fallback if element doesn't exist
  }
} else {
  initCollectionTabs(); // Fallback
}

// PERF: Wait for jQuery to be available before executing jQuery-dependent code
(function () {
  'use strict';

  function waitForJQuery(callback) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined') {
      callback(jQuery);
    } else {
      setTimeout(function () {
        waitForJQuery(callback);
      }, 50);
    }
  }

  waitForJQuery(function ($) {
    // menu open flow code start
    $(document).ready(function () {
      $('.menu-label-first').each(function () {
        $(this).click(function () {
          let menuLabelFirst = $(this).attr('menulable');
          //alert(menuLabelFirst);
          localStorage.setItem('Menu Label First', menuLabelFirst);
          if (menuLabelFirst != 'FANDOMS') {
            localStorage.setItem('Menu Label Second', ' ');
          }
        });
      });

      $('.site-header__button__first-level').click(function () {
        localStorage.setItem('Menu Label First', ' ');
      });

      $('.backtop-first-level').click(function () {
        localStorage.setItem('Menu Label First', ' ');
      });
      $('.back__top_second-level').click(function () {
        localStorage.setItem('Menu Label Second', ' ');
      });

      $('.childer-title').each(function () {
        $(this).click(function () {
          let menuLabelSecond = $(this).attr('second-level-title');
          //alert(menuLabelSecond);
          localStorage.setItem('Menu Label Second', menuLabelSecond);
        });
      });

      let allClearClick = $('.site-header__mobile .site-header__mobile-logo');
      $(allClearClick).click(function () {
        localStorage.setItem('Menu Label First', ' ');
        localStorage.setItem('Menu Label Second', ' ');
      });
    });
    // menu open flow code end

    // cart update code start
    function cartUpdateItem() {
      return;
      setTimeout(function () {
        let cartItemVlaue = $('.cart-item-code');
        $.getJSON('/cart.js', function (cart) {
          var result = cart.item_count;
          // alert(result);
          $(cartItemVlaue).text(result);
        });
      }, 2000);
    }
    $('#AddToCart').click(function () {
      cartUpdateItem();
    });
    $('.fixed-product-form__atc').click(function () {
      cartUpdateItem();
    });
    $('#CartDrawer').click(function () {
      cartUpdateItem();
    });
    // cart update code end

    document.addEventListener('DOMContentLoaded', function () {
      // Function to scroll to a specific element by ID
      function scrollToElement(elementId) {
        var element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }

      // Scroll to the desired element on window load if the window width is less than 768px
      window.onload = function () {
        if (window.innerWidth < 768) {
          // alert("hello")
          scrollToElement('hc-get-started-with-your-exchange-or-return-1');
        }
      };
    });

    $(document).ready(function () {
      var currentUrl = window.location.href;
      if (currentUrl.includes("en-gb")) {
        if (!window.afterpayInterval) { // Ensure interval is created only once
          window.afterpayInterval = setInterval(function () {
            $('.cart-afterpay').hide();
          }, 200);
        }
      }
    });
    // search no result found start
    $(document).ready(function () {
      // Check if an element with class "search-count" exists
      if ($('.search-count').length > 0) {
        // alert('Search Count Element Found!');
        $('.square-image-blocks-main').remove();
        $('.search-collection-carousel').remove();
      }
    });

    $(document).ready(function () {
      if (!window.searchInterval) { // Ensure interval is created only once
        window.searchInterval = setInterval(function () {
          if (!$("#predictive-search-results-list").length > 0) {
            $('.desktop-top-result-not-search-main').show();
          } else {
            $('.desktop-top-result-not-search-main').hide();
          }
        }, 3000); // Increased from 1000ms to 3000ms to reduce CPU usage
      }
    });
    // search no result found end

    // sticky menu issue
    $(document).ready(function () {

      // Check if .option-Length exists, if it does, don't run the script
      if ($(".option-Length").length) {
        return;
      }

      // Initial check on page load
      checkVisibility();

      // Check visibility on window scroll
      $(window).scroll(function () {
        checkVisibility();
      });

      function checkVisibility() {
        let addToCart = $('#AddToCart');
        let stickyCart = $('.fixed-form');
        // PERF: Check if elements exist before accessing them
        if (addToCart.length === 0 || stickyCart.length === 0) {
          return;
        }
        if (isElementInViewport(addToCart)) {
          $(stickyCart).removeClass('fixed-form-sticky');
        } else {
          $(stickyCart).addClass('fixed-form-sticky');
        }
      }

      function isElementInViewport(element) {
        // PERF: Robust null checks to prevent getBoundingClientRect errors
        try {
          // Check if element is a valid jQuery object with at least one DOM element
          if (!element || !element.length || element.length === 0) {
            return false;
          }
          // Get the raw DOM element safely
          var domElement = element.get(0);
          if (!domElement || typeof domElement.getBoundingClientRect !== 'function') {
            return false;
          }
          var rect = domElement.getBoundingClientRect();
          var windowWidth = $(window).width();
          if (windowWidth > 1024) {
            return (
              rect.top >= 120 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
          } else {
            return (
              rect.top >= 55 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
          }
        } catch (e) {
          // Fail silently if any error occurs
          return false;
        }
      }
    });


    // product slider issue start
    $(document).ready(function () {
      let thumblenght = $('.slider-nav button').length;
      if (thumblenght > 3) {
        $('.prd-slide-mob').hide();
      } else {
        $('.product-slider-main-desk').hide();
      }
      // $('.carousel__buttons-next').click(function(){
      //   let firstdot = $('.product-carousel__dot:first-child');

      //   setTimeout(function(){
      //     let clonedDot = $(firstdot).clone(true); // true indicates deep copy
      //     $(firstdot).remove();
      //     $('.thumb-box-product').append(clonedDot);
      //     console.log(clonedDot);
      //   }, 100);
      // });

      function sliderdesk() {
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          asNavFor: '.slider-nav',
        });
        $('.slider-nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: true,
          asNavFor: '.slider-for',
          dots: false,
          arrows: true,
          focusOnSelect: true,
          centerMode: false,
          verticalSwiping: true,
          accesibility: false,
          waitForAnimate: false  // Prevent animation queuing
        });

        // Force position refresh after initialization to ensure proper layout
        setTimeout(function () {
          if ($('.slider-for').hasClass('slick-initialized')) {
            $('.slider-for').slick('setPosition');
          }
          if ($('.slider-nav').hasClass('slick-initialized')) {
            $('.slider-nav').slick('setPosition');
          }
        }, 100);
      }

      var mediaTabs = $('.media-tab');
      if (mediaTabs.length > 1) {
        // Remove all elements except the first one
        mediaTabs.not(':first').remove();
      }

      var mediaTabsPrd = $('.media-main-prd');
      if (mediaTabsPrd.length > 1) {
        // Remove all elements except the first one
        mediaTabsPrd.not(':first').remove();
      }

      // Wait for CSS to be fully loaded before initializing sliders
      function waitForCSS(callback) {
        // Check if custom.css is loaded by testing for a specific rule
        var testElement = $('.product-img-slide .slider-for');
        if (testElement.length && testElement.css('width') !== '0px') {
          callback();
        } else {
          setTimeout(function () { waitForCSS(callback); }, 50);
        }
      }

      // Initialize sliders after CSS is ready
      waitForCSS(function () {
        sliderdesk();
        $('.product-img-slide .slider-for .w-full picture').show();
      });

      // Refresh slick after images load to fix thumbnail cutoff
      $('.slider-nav img').on('load', function () {
        if ($('.slider-nav').hasClass('slick-initialized')) {
          $('.slider-nav').slick('setPosition');
        }
      });

      // Handle viewport resize to fix thumbnail cutoff
      let resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if ($('.slider-nav').hasClass('slick-initialized')) {
            $('.slider-nav').slick('setPosition');
          }
        }, 250); // Debounce resize events
      });

      // $('.product-swatch__group').click(function(){
      //   $('button[aria-label="Go to slide 1"]').trigger('click');
      // })

      //   $('.product-swatch__group').click(function() {
      //   var imageurl = $(this).attr('option_image');

      //   // alert(imageurl);
      //   $('.media-tab img').attr("src", imageurl);
      //   $('.media-tab img').attr("srcset", imageurl);
      //   $('.media-main-prd img').attr("src", imageurl);
      //   $('.media-main-prd img').attr("srcset", imageurl);

      //   // Check if '.media-tab' has class 'media-tab-active'
      //   if (!$('.media-tab').hasClass('media-tab-active')) {
      //     $('.media-tab').addClass('media-tab-active');
      //     $('.media-tab').trigger('click');
      //   }
      // });

      $('.product-swatch__group').click(function () {
        // Skip carousel navigation for size and length variants
        // Size/length swatches are inside .option-size or .option-length containers
        if ($(this).closest('.option-size, .option-length').length > 0) {
          return; // Don't navigate carousel for size changes
        }

        // Check if any '.slick-prev' contains '.media-tab'
        if ($('.slider-nav .media-tab').length === 0) {
          $('button[aria-label="Go to slide 1"]').trigger('click');
        } else {
          var imageurl = $(this).attr('option_image');
          // alert(imageurl);
          $('.media-tab img').attr("src", imageurl);
          $('.media-tab img').attr("srcset", imageurl);
          $('.media-main-prd img').attr("src", imageurl);
          $('.media-main-prd img').attr("srcset", imageurl);

          // Check if '.media-tab' has class 'media-tab-active'
          if (!$('.media-tab').hasClass('media-tab-active')) {
            $('.media-tab').addClass('media-tab-active');
            $('.media-tab').trigger('click');
          }
        }
      });

      $('.slider-nav button').click(function () {
        if (!$(this).hasClass('media-tab-active')) {
          $('.media-tab').removeClass('media-tab-active');
        }
      });

      //zoom function
      $('.zoom_button_prd_img').click(function () {
        let imageUrl = $('.slider-for .slick-active .main-image-box').attr('mediaLink');
        // alert(imageUrl);
        $('.main-zoom-box-inner .image-box img').attr('src', imageUrl);
        $('.main-zoom-box').fadeIn();
        $('body').addClass('stop_scroll');
      });
      $('.main-zoom-box .close-btn').click(function () {
        // let imageUrl = $('.slider-for .slick-active .main-image-box').attr('mediaLink');
        // alert(imageUrl);
        $('.main-zoom-box-inner .image-box img').attr('src', ' ');
        $('.main-zoom-box').fadeOut();
        $('body').removeClass('stop_scroll');
      });

    });

    $(document).ready(function () {
      $(".product__images .prd-slide-mob").dblclick(function () {
        //alert("hello");
        $('button[js-open-gallery-zoom]').trigger('click');
      });
    });

    // $("body").on("dblclick", function(){
    //   alert("body dbl")
    // });

    $(".product__images .main-image-box").dblclick(function () {
      //alert("hello");
      $('.zoom_button_prd_img').trigger('click');
    });
    // product slider issue end


    $(document).ready(function () {
      $('.coll_sub_head_desc .read_btn').click(function () {
        $('.coll_sub_head_desc').addClass('coll_sub_head_desc_show_all')
      });
      $('.coll_sub_head_desc .read_less').click(function () {
        $('.coll_sub_head_desc').removeClass('coll_sub_head_desc_show_all')
      });
    });

    /// One cart js start ///
    $(document).ready(function () {
      function hideQty() {
        $('.line-item__qty-selector').each(function () {
          // Retrieving the 'alt' attribute of the current element
          var altText = $(this).attr('alt');

          // Checking if 'altText' contains the string "One_cart"
          if (altText && altText.includes("One_cart")) {
            // console.log("yes");
            $(this).hide();
          }
        });
      }

      function checkCartId() {
        return;
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function (cart) {
            let prdPageId = $('#AddToCart').attr('prdurl');
            // console.log("prdPageId:", prdPageId);

            let found = false;

            $.each(cart.items, function (index, item) {
              // console.log("item.id:", item.product_id);
              // console.log(item);
              if (item.product_id.toString() === prdPageId.toString()) {
                // alert('yes');
                $('#AddToCart').hide();
                $('.fixed-form').hide();
                found = true;
                return false;
              }
            });

            if (!found) {
              // alert('no');
              $('#AddToCart').show();
              $('.fixed-form').show();
            }
          },
          error: function (xhr, status, error) {
            console.error("Error fetching cart:", error);
          }
        });
      }

      // Optimized intervals - reduced frequency and combined functionality
      if (!window.cartUpdateInterval) {
        window.cartUpdateInterval = setInterval(function () {
          hideQty();
          checkCartId();
        }, 5000); // Increased from 2000ms to 5000ms
      }

      // Removed separate hideQtyInterval to reduce CPU usage
      // Initial run
      checkCartId();
    });


    /// One cart js end ///

    /// account js start
    $(document).ready(function () {
      $('.site-header__destkop-account[js-account-dropdown-trigger]').click(function (event) {
        event.stopPropagation(); // Prevent the click event from propagating to the body
        $(this).toggleClass('active');
      });

      $('body').click(function () {
        $('.site-header__destkop-account[js-account-dropdown-trigger]').removeClass('active');
      });

      // $(".site-header__destkop-account").mouseover(function(e){
      //   e.stopPropagation();
      //    e.preventDefault();
      //   // alert("hello");
      // })
    });

    /// account js end



    $(document).ready(function () {

      /// collection comming soon js start
      $(document).ready(function () {
        $('.coll_prd_comming_soon_notify_3').click(function (e) {
          e.preventDefault();
          // alert("Hello");
          $('.klaviyo-new-popup-main_notify_new_3').addClass('klaviyo-new-popup-main-open');
        });
        $('.coll_prd_comming_soon_notify_4').click(function (e) {
          e.preventDefault();
          $('.klaviyo-new-popup-main_notify_new_4').addClass('klaviyo-new-popup-main-open');
        });
        $('.coll_prd_comming_soon__notify_meta').click(function (e) {
          e.preventDefault();
          // $('.klaviyo-new-popup-main_notify_new_4').addClass('klaviyo-new-popup-main-open');
          // alert("clicked");
          var notifybtnid = $(this).attr('notify_meta');
          // alert(notifybtnid);
          $('.klaviyo-new-popup-main_notify_meta').each(function () {
            var formId = $(this).attr('notify_form_prd_id');
            if (notifybtnid === formId) {
              // alert(`${formId} matched`);
              $(this).addClass('klaviyo-new-popup-main-open');
            }
          });
        });
        var addToCartText = $("#AddToCart").text().trim();
        if (addToCartText == 'Sold Out') {
          $('.fixed-product-form__atc').text("Sold Out");
          $('.fixed-product-form__atc').attr("disabled", true);
        }
      });
      /// collection comming soon js end

      /// Search bar cross icon js start
      var desksearchinput = $("#desktop-search");

      // Desktop JS
      $(document).on('input', '#desktop-search', function () {
        var desksearch = $(this).val();
        if (desksearch.length > 0) {
          $('.desktop_clear_search').show();
        } else {
          $('.desktop_clear_search').hide();
        }
      });
      $(document).on('click', '.desktop_clear_search', function () {
        // $('#desktop-search').val("").focus();
        $('#desktop-search').val("");
        setTimeout(function () {
          var event = new Event('input', {
            bubbles: true,
            cancelable: true
          });
          $('#desktop-search')[0].dispatchEvent(event);
        }, 500);
        setTimeout(function () {
          $('.desktop_clear_search').hide();
        }, 600);
      });

      // Mobile JS
      // Show close button when search input is focused and ensure fallback opens
      // Using direct binding instead of delegation to catch native focus events
      $('.mobile-search-input').on('focus', function () {
        $('.mobile_clear_search').show();
        // Also ensure fallback opens if input is empty
        var $fallback = $('#search-fallback');
        var $fallbackGrid = $('.predictive_grid_main');
        
        if ($(this).val().trim().length === 0) {
          $fallback.removeClass('hidden').attr('aria-hidden', 'false');
          // Ensure fallback grid content is visible (PredictiveSearch component may have hidden it)
          $fallbackGrid.removeClass('hidden');
        }
      });

      // Keep close button visible as long as search fallback is open
      $(document).on('input', '.mobile-search-input', function () {
        var $fallback = $('#search-fallback');
        var isFallbackVisible = $fallback.length && !$fallback.hasClass('hidden');
        // Always show if fallback is visible, regardless of input length
        if (isFallbackVisible || $(this).val().length > 0) {
          $('.mobile_clear_search').show();
        }
      });

      // Close button click: close the entire search interface
      $(document).on('click', '.mobile_clear_search', function (e) {
        e.preventDefault();
        var $input = $('.mobile-search-input');
        var $fallback = $('#search-fallback');
        var $predictiveMenu = $('.mobile-search-container');
        
        // Clear the input
        $input.val('');
        
        // Hide the close button
        $('.mobile_clear_search').hide();
        
        // Close the search fallback
        $fallback.addClass('hidden').attr('aria-hidden', 'true');
        
        // Close the predictive search results menu
        $predictiveMenu.addClass('hidden');
        
        // Blur the input to remove focus
        $input.blur();
        
        // Trigger the search:close event to unlock announcement bar and scroll
        $(window).trigger('search:close');
      });
      /// Search bar cross icon js end

      // product afterpay popup js start
      $('span.afterpay_more_info').click(function () {
        $('.afterpay_popup_main').addClass('afterpay_popup_main_open');
      });
      $('span.afterpay_close').click(function () {
        $('.afterpay_popup_main').removeClass('afterpay_popup_main_open');
      });
      // product afterpay popup js end
    });

    $(".fixed-product-form__atc").click(function () {
      $(".product_atc").trigger("click");
    });
  }); // End of waitForJQuery wrapper
})();

// ===================================
// Header Rewards Dropdown
// ===================================
document.addEventListener('DOMContentLoaded', function () {
  initRewardsDropdown();
});

function initRewardsDropdown() {
  const dropdownContainer = document.querySelector('[js-rewards-dropdown]');
  if (!dropdownContainer) return;

  const trigger = dropdownContainer.querySelector('[js-rewards-dropdown-trigger]');
  const panel = dropdownContainer.querySelector('[js-rewards-dropdown-panel]');

  if (!trigger || !panel) return;

  let isOpen = false;
  let hoverTimeout = null;

  // Toggle function
  function openDropdown() {
    isOpen = true;
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDropdown() {
    isOpen = false;
    panel.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  // Desktop: Hover behavior
  dropdownContainer.addEventListener('mouseenter', function () {
    clearTimeout(hoverTimeout);
    openDropdown();
  });

  dropdownContainer.addEventListener('mouseleave', function () {
    hoverTimeout = setTimeout(function () {
      closeDropdown();
    }, 150); // Small delay to prevent accidental close
  });

  // Click behavior (for accessibility and touch devices)
  trigger.addEventListener('click', function (e) {
    e.preventDefault();

    // Check if user is logged out - if so, open login modal instead
    if (trigger.hasAttribute('data-logged-out')) {
      // Find and click the login button to open the modal
      const loginButton = document.querySelector('[js-login-desktop]');
      if (loginButton) {
        loginButton.click();
      }
      return;
    }

    // Otherwise, toggle dropdown normally
    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {
    if (!dropdownContainer.contains(e.target) && isOpen) {
      closeDropdown();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      closeDropdown();
      trigger.focus();
    }
  });

  // Keyboard navigation
  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openDropdown();
      // Focus first focusable element in panel
      const firstLink = panel.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
  });
}
